/**
 * @return {string}
 */
export default function getInstallationId() {
  // TODO: use __APP__ counter part wrapped with the new store setup function instead of this legacy object
  // eg: webappStore.getInstanceId
  return window?.$dt?.objConfig?.InstanceId || '';
}
